import React from 'react';
import { useIntl } from 'umi';
import AllCompanySelector from '@intelligence/components/AllCompanySelector';
import { isNotEmpty } from '@intelligence/v3/utils/common';
import { getPreviewTitle } from '../previewHelpers';
import { getStringArrayValue } from '../shared/valueUtils';
import { FILTER_TYPE } from '../filterTypes';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule } from '../controlModule';
import type { ICompanyFilterValue } from './types';

const CompanySelectRenderer: React.FC<IFilterRenderProps<ICompanyFilterValue>> = (props) => {
  const { field, value, onChange, ...rest } = props;

  return (
    <AllCompanySelector
      {...rest}
      key={field}
      value={getStringArrayValue(value)}
      onConfirm={(payload: string[]) => {
        onChange(payload);
      }}
    />
  );
};

const CompanyPreview: React.FC<{
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0];
  valueItem: any;
}> = (props) => {
  const { item, valueItem } = props;
  const { formatMessage } = useIntl();
  const value = Array.isArray(valueItem) ? valueItem : [];

  let content: React.ReactNode = formatMessage({ id: 'dbi_all' });
  if (value.length > 2) {
    content = value.length;
  } else if (isNotEmpty(value)) {
    content = value.join(', ');
  }

  return (
    <>
      <span className="model-form-text">{getPreviewTitle(item, formatMessage)}</span>
      <span className="model-form-context">{content}</span>
    </>
  );
};

// eslint-disable-next-line react/display-name
function renderCompanyPreview(
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0],
  value: any,
): React.ReactNode {
  return <CompanyPreview item={item} valueItem={value} />;
}

const getRenderPreview = (): NonNullable<IFilterTypeEntry['renderPreview']> => {
  return renderCompanyPreview;
};

export const companySelectControl: IFilterControlModule = {
  type: FILTER_TYPE.COMPANY_SELECT,
  entry: {
    render: (props) => {
      return <CompanySelectRenderer {...props} />;
    },
  },
  getRenderPreview,
};
